import React from 'react';
import ScheduleDemoBtn from '../../../image/home/Swasth-provider-Schedule-demo-btn.png';
import ScheduleDemoImg from '../../../image/home/Swasth-provider-360-degree-view-graphic.png';

function LandingContent() {
  return (
    <div className='landing_content'>
      <h1 className='heading base-text'>
       Behavioral Health Platform for Evidence-Based Therapy
      </h1>
      <p className='description para-text'>
        We provide evidence-based Digital Therapy tools that are simple and
        effective. By reviewing your clients' behavioral health data in real-time you can better
        tailor your treatment approach.
      </p>
      <div className='schedule-demo-container'>
        <img src={ScheduleDemoImg} alt='Schedule Demo' className='' />
        <a href='https://calendly.com/resiliens-inc/informational-session' target='_blank'>
          <img src={ScheduleDemoBtn} alt='Schedule Demo Btn' />
        </a>
      </div>
    </div>
  );
}

export default LandingContent;
